





















import Vue from 'vue'
import { mapGetters, mapActions } from 'vuex'

import dayjs from 'dayjs'

export default Vue.extend({
  name: 'ProofCardList',

  components: {
    ProofCard: () => import('./ProofCard.vue'),
    DateSeparator: () => import('./DateSeparator.vue'),
  },

  data() {
    return {
      offsetTop: 0,
      offset: 0,
      limit: 10,
      loading: false,
      shouldLoadMore: true,
      proofList: [],
    }
  },

  computed: {
    ...mapGetters('timeline', ['proofs', 'queryDate']),
    groupProofs() {
      const group = this.proofList.reduce((reducer, accumulator) => {
        const date = dayjs(accumulator.proof_date.split('.')[0]).format('YYYY-MM-DD')
        const blob = {
          date: '',
          proofs: [],
        }

        reducer[date] = reducer[date] || blob
        reducer[date].date = dayjs(accumulator.proof_date.split('.')[0]).toDate()
        reducer[date].proofs.push(accumulator)

        return reducer
      }, {})

      return group
    },
  },

  watch: {
    queryDate() {
      this.loading = false
      this.shouldLoadMore = true
      this.offset = 0
      this.proofList = []
      this.checkStickySeparators()
    },
    proofs() {
      const newProofIds = this.proofs.map((proof) => proof.id)
      const loadedProofs = this.proofList.filter((proof) => {
        return !newProofIds.includes(proof.id)
      })

      this.proofList = loadedProofs.concat(this.proofs)
    },
  },

  mounted() {
    this.$store.dispatch('timeline/refresh', {})
    this.checkStickySeparators()
  },

  methods: {
    ...mapActions('timeline', ['refresh']),

    onScroll(event) {
      if (this.loading || !this.shouldLoadMore) return

      // NOTE: Mac and PC return scrollTop as a different number
      this.offsetTop = Math.ceil(event.target.scrollTop)
      const bottomOfWindow = this.offsetTop >= event.target.scrollHeight - event.target.clientHeight

      if (bottomOfWindow) {
        this.getProofs()
      }
    },

    // NOTE: This remains because the evaluation of the filter does not return
    //       the same result as passing the date into the function.
    prettyDate(date) {
      return dayjs(date).format('MMMM DD, YYYY')
    },

    getProofs() {
      this.loading = true
      this.offset = this.offset + this.limit

      const params = [`offset=${this.offset}`, `limit=${this.limit}`]

      this.refresh({ selectedDate: this.queryDate, params }).finally(() => {
        this.loading = false
        this.shouldLoadMore = this.proofs.length === this.limit
        this.setObserver()
      })
    },

    checkStickySeparators() {
      const interval = setInterval(() => {
        const stickySeparators = document.querySelectorAll('.proof-date-separator')
        if (stickySeparators) {
          clearInterval(interval)
          this.setObserver()
        }
      }, 500)
    },

    setObserver() {
      //-- Referencing: https://codepen.io/talmand/pen/ExYLayz
      //                https://css-tricks.com/an-explanation-of-how-the-intersection-observer-watches/#creating-a-position-sticky-event
      const stickySeparators = document.querySelectorAll('.proof-date-separator')
      const observerOptions = {
        root: document.querySelector('#proof-card-list'),
        rootMargin: '0px 0px -95% 0px',
        threshold: 0,
      }

      const observer = new IntersectionObserver(this.observerCallback, observerOptions)

      stickySeparators.forEach((element) => {
        observer.observe(element)
      })
      //-- END
    },

    observerCallback(entries, observer) {
      entries.forEach((entry) => {
        entry.target.classList.toggle('active', entry.isIntersecting)
      })

      // NOTE:  In the example, https://codepen.io/talmand/pen/ExYLayz, this sub-checking
      //        is not needed. Not sure why it's not working like the example.
      const activeSelectorList = document.querySelectorAll('.proof-date-separator.active')
      if (activeSelectorList.length) {
        this.$store.dispatch('timeline/stickyDate', activeSelectorList[activeSelectorList.length - 1].getAttribute('data-proofs-date'))
      }
    },
  },
})
